<template>
    <div>

        <h2>When the times comes to transition the leadership of the family business, which of the following best describes the transition you expect for the family business?</h2>

        <ul class="quiz">
            <li :class="(q11 == 1 ? 'checked' : '')" @click="sc('q11', 1)">Within the family</li>
            <li :class="(q11 == 2 ? 'checked' : '')" @click="sc('q11', 2)">Outside the family</li>
            <li :class="(q11 == 3 ? 'checked' : '')" @click="sc('q11', 3)">Transitioning to nonfamily leadership (e.g. CEO)</li>
            <li :class="(q11 == 4 ? 'checked' : '')" @click="sc('q11', 4)">Not sure</li>
        </ul>

        

        <h2>How important are each of the following for you and the rest of the family that are involved in the family business?</h2>
        <ul class="likert-statement">
            <li>
                <label class="statement">Building a sustainable business for my family</label>
                <ul class='likert likert5'>
                    
                    <li>
                        <input v-model="likertl111" type="radio" id="l1a1" name="likertl111" value="extremely_important" @click="sc('likertl111', 'extremely_important')">
                        <label for="l1a1">Extremely Important</label>
                    </li>
                    <li>
                        <input v-model="likertl111" type="radio" id="l1a2" name="likertl111" value="very_important" @click="sc('likertl111', 'very_important')">
                        <label for="l1a2">Very Important</label>
                    </li>
                    <li>
                        <input v-model="likertl111" type="radio" id="l1a3" name="likertl111" value="somewhat_important" @click="sc('likertl111', 'somewhat_important')">
                        <label for="l1a3">Somewhat Important</label>
                    </li>
                    <li>
                        <input v-model="likertl111" type="radio" id="l1a4" name="likertl111" value="somewhat_not_important" @click="sc('likertl111', 'somewhat_not_important')">
                        <label for="l1a4">Somewhat not Important</label>
                    </li>
                    <li>
                        <input v-model="likertl111" type="radio" id="l1a5" name="likertl111" value="not_important" @click="sc('likertl111', 'not_important')">
                        <label for="l1a5">Not Important</label>
                    </li>
                </ul>
            </li>
            <li>
                <label class="statement">Having someone within the family to take over the business</label>
                <ul class='likert likert5'>
                    <li>
                        <input v-model="likertl112" type="radio" id="l2a1" name="likertl112" value="extremely_important" @click="sc('likertl112', 'extremely_important')">
                        <label for="l2a1">Extremely Important</label>
                    </li>
                    <li>
                        <input v-model="likertl112" type="radio" id="l2a2" name="likertl112" value="very_important" @click="sc('likertl112', 'very_important')">
                        <label for="l2a2">Very Important</label>
                    </li>
                    <li>
                        <input v-model="likertl112" type="radio" id="l2a3" name="likertl112" value="somewhat_important" @click="sc('likertl112', 'somewhat_important')">
                        <label for="l2a3">Somewhat Important</label>
                    </li>
                    <li>
                        <input v-model="likertl112" type="radio" id="l2a4" name="likertl112" value="somewhat_not_important" @click="sc('likertl112', 'somewhat_not_important')">
                        <label for="l2a4">Somewhat not Important</label>
                    </li>
                    <li>
                        <input v-model="likertl112" type="radio" id="l2a5" name="likertl112" value="not_important" @click="sc('likertl112', 'not_important')">
                        <label for="l2a5">Not Important</label>
                    </li>
                </ul>
            </li>
            <li>
                <label class="statement">Working together as a family</label>
                <ul class='likert likert5'>
                    <li>
                        <input v-model="likertl113" type="radio" id="l3a1" name="likertl113" value="extremely_important" @click="sc('likertl113', 'extremely_important')">
                        <label for="l3a1">Extremely Important</label>
                    </li>
                    <li>
                        <input v-model="likertl113" type="radio" id="l3a2" name="likertl113" value="very_important" @click="sc('likertl113', 'very_important')">
                        <label for="l3a2">Very Important</label>
                    </li>
                    <li>
                        <input v-model="likertl113" type="radio" id="l3a3" name="likertl113" value="somewhat_important" @click="sc('likertl113', 'somewhat_important')">
                        <label for="l3a3">Somewhat Important</label>
                    </li>
                    <li>
                        <input v-model="likertl113" type="radio" id="l3a4" name="likertl113" value="somewhat_not_important" @click="sc('likertl113', 'somewhat_not_important')">
                        <label for="l3a4">Somewhat not Important</label>
                    </li>
                    <li>
                        <input v-model="likertl113" type="radio" id="l3a5" name="likertl113" value="not_important" @click="sc('likertl113', 'not_important')">
                        <label for="l3a5">Not Important</label>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>


<script>


function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
    name: "quiz1",
    components: {

    },
    data() {
        return {
            q21: (getCookie("q21") ? getCookie("q21") : 0),
            q11: (getCookie("q11") ? getCookie("q11") : 0),
            likertl151: (getCookie("likertl151") ? getCookie("likertl151") : 0),
            likertl152: (getCookie("likertl152") ? getCookie("likertl152") : 0),
            likertl153: (getCookie("likertl153") ? getCookie("likertl153") : 0),
            likertl154: (getCookie("likertl154") ? getCookie("likertl154") : 0),

            likertl111: (getCookie("likertl111") ? getCookie("likertl111") : 0),
            likertl112: (getCookie("likertl112") ? getCookie("likertl112") : 0),
            likertl113: (getCookie("likertl113") ? getCookie("likertl113") : 0),
        };
    },
 
    methods: {
        sc(c,v) {
            if (c == "q21") { this.q21 = v; }
            if (c == "q11") { this.q11 = v; }
            if (c == "likertl151") { this.likertl151 = v; }
            if (c == "likertl152") { this.likertl152 = v; }
            if (c == "likertl153") { this.likertl153 = v; }
            if (c == "likertl154") { this.likertl154 = v; }

            if (c == "likertl111") { this.likertl111 = v; }
            if (c == "likertl112") { this.likertl112 = v; }
            if (c == "likertl113") { this.likertl113 = v; }
            
            
            setCookie(c,v);
        },
    }
    
}

</script>
